
import axios from "axios";

const API_URL = "/api/auth";

export const loginUser = async (data) => {
    const requestData = {
        email: data.email?.trim(),
        password: data.password
    };

    return axios.post(`${API_URL}/login`, requestData, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};
